import $ from "jquery";

export default class Feature {
  constructor() {
    this.example = 'example';
  }

  init() {
    this.example = 'initialized';
    console.log("init this ************");
  }
}



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_imp_v2/package/src/maternity-buying-guide.js